/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from 'Docs/uilib/components/form-label/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.Default) _missingMdxReference("Examples.Default", true);
  if (!Examples.LinkedLabel) _missingMdxReference("Examples.LinkedLabel", true);
  if (!Examples.NoForId) _missingMdxReference("Examples.NoForId", true);
  if (!Examples.Vertical) _missingMdxReference("Examples.Vertical", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default form-label"
    }), "\n", _jsx(Examples.Default, {}), "\n", _jsx(_components.h3, {
      children: "Vertical form-label"
    }), "\n", _jsx(Examples.Vertical, {}), "\n", _jsxs(_components.h3, {
      children: ["Vertical form-label without a ", _jsx(_components.code, {
        children: "for_id"
      })]
    }), "\n", _jsx(Examples.NoForId, {}), "\n", _jsx(_components.h3, {
      children: "Linked label (pattern)"
    }), "\n", _jsx(Examples.LinkedLabel, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
